export default __webpack_public_path__ + "static/media/laccan.625bd262.svg";